import React from 'react';

export const pageMeta = {
  "name": "JS Events",
  "link": "/javascript/events"
};

export default function JavascriptEvents() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Events</h2>
      <p>Route: /javascript/events</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
